import React, { SVGProps } from 'react';

export const CanvaPresentation = ( props: SVGProps<SVGSVGElement> ) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{ ...props }
	>
		<rect width='24' height='24' rx='5' fill='#E8453C' />
		<rect x='4' y='5' width='16' height='11' rx='1.5' fill='white' />
		<rect x='10.25' y='16' width='3.5' height='1.5' rx='0.5' fill='white' />
		<rect x='8.5' y='17.5' width='7' height='1.25' rx='0.5' fill='white' />
	</svg>
);
